import type { BetType } from '../../../store/slices/bets/types';
import { ChipTypes } from '../../../store/slices/chips/types';

import type { ComputedBet } from './types';

export const getComputedBets = (betStack: BetType[]): ComputedBet[] => {
  const bet = betStack[betStack.length - 1];

  if (bet) {
    const betKeys: string[] = Object.keys(bet.betSpots);
    return betKeys.reduce((computedBets: ComputedBet[], betId: string) => {
      const betSpot = bet?.betSpots[betId];
      if (betSpot?.value) {
        const { count, type, value } = betSpot;
        const betObj: ComputedBet = { betId: Number(betId), value, type };
        if (type === ChipTypes.FreeChip) {
          betObj.count = count;
        }
        computedBets.push(betObj);
      }
      return computedBets;
    }, []);
  }

  return [];
};
